var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col content-header-col d-flex"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }